import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 言語jsonファイルのimport
import translation_ja from './ja.json';

const resources = {
  ja: {
    translation: translation_ja
  }
};

void i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    interpolation: {
      escapeValue: false // React already safes from xss
    },
    lng: 'ja',
    resources
  });

export default i18n;
